export const receiveType: number = 3